document.addEventListener('DOMContentLoaded', function () {

  function updateQuantityM2(component) {
    const input = component.querySelector('input[ref="quantityInput"]');
    const display = component.nextElementSibling;

    if (!input || !display || !display.hasAttribute('data-quantity-m2-display')) {
      return;
    }

    const quantity = parseInt(input.value, 10) || 1;
    const m2 = quantity;

    const boxText = quantity === 1 ? 'box' : 'boxes';
    const m2Text = Number.isInteger(m2) ? m2 : m2.toFixed(1);

    display.textContent = `${quantity} ${boxText} = ${m2Text} m²`;
  }

  function updateAllQuantityM2() {
    document.querySelectorAll('quantity-selector-component').forEach(function (component) {
      updateQuantityM2(component);
    });
  }

  // Initial update
  updateAllQuantityM2();

  // Update after + / -
  document.addEventListener('click', function (event) {
    if (event.target.closest('.quantity-plus, .quantity-minus')) {
      setTimeout(updateAllQuantityM2, 150);
    }
  });

  // Update after manually changing quantity
  document.addEventListener('change', function (event) {
    if (event.target.matches('input[ref="quantityInput"]')) {
      setTimeout(updateAllQuantityM2, 150);
    }
  });

});